import { csx } from '@vtex/admin-ui'

const styles = {
  inputContainer: csx({
    maxWidth: 200,
    marginRight: '$space-4',
    width: '100%',
  }),
}

export default styles
